import React from 'react';
import PropTypes from 'prop-types';
import './InputField.scss';

const InputField = (props) => (
    <input className="input" type={props.type} name={props.name} placeholder={props.placeholder}></input>
);

InputField.propTypes = {
    type: PropTypes.string,
    name: PropTypes.string,
    placeholder: PropTypes.string
};

InputField.defaultProps = {
    type: "text",
    name: "text",
    placeholder: "Enter text here"
};

export default InputField;
